// extracted by mini-css-extract-plugin
export default {"overlay":"_G-z","bodyOpen":"aH-z","content":"bH-z","header":"cH-z","close":"dH-z","closeNoHeading":"eH-z"};